<template>
  <ve-histogram
    :data="chartData"
    :settings="chartSettings"
    width="300px"
    height="300px"
  ></ve-histogram>
</template>

<script>
export default {
  props: {
    chartData: {
      type: Object,
    },
  },
  data() {
    this.chartSettings = this.chartData.chartSettings;
    return {};
  },
};
</script>
